import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Tablet"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.25 18V19.5H9.75V18H14.25ZM5.25 22.5H18.75C19.5779 22.4988 20.2488 21.8279 20.25 21V3C20.2492 2.17192 19.5781 1.50083 18.75 1.5H5.25C4.42192 1.50083 3.75083 2.17192 3.75 3V21C3.75083 21.8281 4.42192 22.4992 5.25 22.5ZM5.25 21V3H18.75V21H5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Tablet.vue"]]);
